const ECODETYPE = {
  Barcode: "1",
  QR: "2",
};

export {
  // eslint-disable-next-line import/prefer-default-export
  ECODETYPE,
};
